module.exports = "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAAAQAwCdASoZABkAPpFCnEolo6KkqAgAsBIJZwCzgBalxwAA/vMMPFwyGHE3YcBAGBdkiptesnanyGBKJpcH+AAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/sand.webp
// module id = xurB
// module chunks = 14